import { ClaimPrinciple } from '../interfaces/claim-principle';




export class Claims {
    public CanEnterSettings:boolean;
    public CanDefineScopeOfActivity:boolean;
    public CanAddOrEditDepartments:boolean; // deleted - only for SU
    public CanAddNewBusinessOrBranch:boolean; // deleted - only for SU
    public CanEditBusinessOrBranch:boolean; // only for Branch, edit business - only for SU
    public CanAddNewPatient:boolean;
    public CanEditPatient:boolean;
    public CanEditPatientMedications:boolean;
    public CanEditPatientAnamneza:boolean;
    public CanEditPatientRemarks:boolean;
    public CanViewPatientMedicalData:boolean;
    public CanViewMedicalWarningIndicators:boolean;
    public BlockAccessForOtherTherapists:boolean;
    public CanEditConfidentialPatients:boolean;
    public CanEditPermissionGroup:boolean;
    public CanCreateRetroAppointment:boolean;
    public CanAddorEditBlocks:boolean;
    public CanDeleteCustomerDocument:boolean;
    public CanEditVisitSummary:boolean;
    public CanAccessToReportGenerator:boolean;
    public CanAccessFormManager:boolean;
    public AutoLockAfter5Minutes:boolean;
    public HidePrice:boolean;
    public CanCreatePrescription:boolean;
    public CanEditMedicine:boolean;
    public CanViewMainScreenAndGenerateReports:boolean;
    public CanAccessCustomerAccount:boolean;
    public CanReceivePaymentAndMore:boolean;
    public CanGenerateSpecialDocuments:boolean;
    public RequiredRoomInAppointment:boolean;
    public PreventAppointmentDurationChange:boolean;
    public PreventAppointmentTimeChange:boolean;
    public PreventAppointmentCancellation:boolean;

    constructor(private claims: ClaimPrinciple[]){
        for (let index = 0; index < claims.length; index++) {            
            const element = claims[index];
            this[element.ClaimResourcesData] = true;
        }
        
    }
    
}


